import React, { useEffect, useState } from 'react';
import productionMonitorService from '../../../../service/client/varadiMetal/productionMonitor.service';
import { DatePickerUI, DebouncedInputUI, FormLabelUI } from '../../../Interface';
import { Box } from '@mui/material';
import ProductionMonitorTree from './ProgressMapTree';
import dayjs from 'dayjs';
import { useLoader } from '../../../../provider/LoaderProvider';

export const ProgressMapPage = () => {
  const { showLoader, hideLoader } = useLoader();
  const initialState = {
    filter: {
      filterModel: {
        items: [],
        logicOperator: 'and',
      },
    },
  };

  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState(initialState);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    if (query.filter.filterModel.items.find((item) => item.field === 'reference')) {
      getList();
    }
  }, [query.filter]);

  const getList = () => {
    showLoader();
    productionMonitorService
      .getData(query)
      .then((res) => {
        setRows(res);
        setSelectedRow(null);
      })
      .finally(() => {
        hideLoader();
      });
  };

  const handleFilterChange = (field, value) => {
    setQuery((prev) => {
      let newItems = prev.filter.filterModel.items;

      newItems = newItems.filter((item) => item.field !== field);
      if (value !== null && value !== undefined) {
        newItems.push({
          field,
          operator: 'contains',
          value: value,
        });
      }

      return {
        ...prev,
        filter: {
          filterModel: {
            items: newItems,
          },
        },
      };
    });
  };

  const foundedDate = query.filter.filterModel.items.find((item) => item.field === 'dueDate')?.value;

  return (
    <Box px="1rem" minHeight="calc(100vh - 64px)" backgroundColor="#f3f4f6">
      <Box display="flex" gap="1rem" mb="2rem" pt="1rem">
        <Box width="200px">
          <DebouncedInputUI
            label="Vevőhivatkozási szám"
            debounceMs={800}
            setQuickFilterSearchValue={(newVal) => {
              if (newVal) {
                handleFilterChange('reference', newVal);
              } else {
                setRows([]);
                setQuery(initialState);
              }
            }}
            quickFilterSearchValue={query.filter.filterModel.items.find((item) => item.field === 'reference')?.value}
          />
        </Box>
        <Box width="200px">
          <DebouncedInputUI
            label="Cikkszám"
            debounceMs={800}
            setQuickFilterSearchValue={(newVal) => {
              handleFilterChange('itemCode', newVal);
            }}
            disabled={!query.filter.filterModel.items.find((item) => item.field === 'reference')?.value}
            quickFilterSearchValue={query.filter.filterModel.items.find((item) => item.field === 'itemCode')?.value}
          />
        </Box>
        <Box width="200px">
          <DebouncedInputUI
            label="Rendelési szám"
            debounceMs={800}
            setQuickFilterSearchValue={(newVal) => {
              handleFilterChange('docNum', newVal);
            }}
            disabled={!query.filter.filterModel.items.find((item) => item.field === 'reference')?.value}
            quickFilterSearchValue={query.filter.filterModel.items.find((item) => item.field === 'docNum')?.value}
          />
        </Box>
        <Box width="200px">
          <DatePickerUI
            label={<FormLabelUI text="Határidő" />}
            value={foundedDate ? dayjs(foundedDate) : null}
            onChange={(newDate) => {
              handleFilterChange('dueDate', newDate ? dayjs(newDate).format('YYYY-MM-DD') : null);
            }}
            disabled={!query.filter.filterModel.items.find((item) => item.field === 'reference')?.value}
          />
        </Box>
      </Box>
      <Box>
        {rows.length > 0 && <ProductionMonitorTree rows={rows} selectedRowState={{ selectedRow, setSelectedRow }} />}
      </Box>
    </Box>
  );
};
